export function slugifyHeading(text) {
  return text.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

// Every guide article shares one renderer (GuideArticlePage); the slug in
// the URL just selects which brand-specific content data it renders. See
// src/content/guides.js.
export function guideSlugFromPath(pathname) {
  const match = String(pathname || "").match(/^\/guides\/([a-z0-9-]+)\/?$/);
  return match ? match[1] : null;
}
